import { Accordion, AccordionDetails, Grid } from '@mui/material'

import useStyles from '../index.styles'

import AccordionGroup from './accordion-group'

const AccordionGroupBuilding = ({
  building,
  buildingContent,
  isExpanded,
  onToggle,
}: {
  building: IBuildingGroup
  buildingContent: React.ReactNode
  isExpanded: boolean
  onToggle: (key: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void
}) => {
  const classes = useStyles

  return (
    <Accordion data-testid="accordion" expanded={isExpanded} onChange={onToggle(building.name)} sx={[classes.accordion, classes.firstLevelAccordion]}>
      <AccordionGroup.SummaryTopLevel
        label={building.name}
        count={building.floors.reduce((sum, f) => sum + f.devices.length, 0)}
        hasAlert={building.hasAlert}
      />
      <AccordionDetails sx={classes.accordionDetails}>
        <Grid container={true} size={12} sx={classes.deviceGroupDetailsContainer}>
          {buildingContent}
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionGroupBuilding
